import React, { useEffect, useState } from 'react'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { getThaiDAuthenUrl } from '../../../redux/actions/thaid'
import { isEmpty } from 'lodash-es'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

export default function Landing() {
  const [error, setError] = useState()

  useEffect(() => {
    let parameters = location.search.substring(1)?.split('&')

    let refCode = ''
    parameters.forEach((item) => {
      var items = item?.split('=')
      if (items.length == 2 && items[0] == 'refCode') {
        refCode = items[1]
      }
    })

    callApi(refCode)
  }, [])

  const callApi = async (refCode) => {
    try {
      const result = await getThaiDAuthenUrl(refCode)
      if (!isEmpty(result)) {
        window.open(result, '_self')
      } else {
        setError({})
      }
    } catch (e) {
      setError({ errorMessage: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG })
    }
  }

  return (
    <>
      {error ? (
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      ) : (
        <div style={{ padding: 40 }}>
          <OverlayLoader />
          <PanalLoadingTemplate />
        </div>
      )}
    </>
  )
}
